import React from "react";
import "./PromptPayPaymentPage.css"; // สร้างไฟล์ CSS แยกสำหรับสไตล์
import { Button, QRCode, Descriptions, Statistic } from "antd";
import iconPay from "../../assets/images/logo/payeasy1.1.png";
import {
  SafetyCertificateOutlined,
  AlertOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import config from "../../config/app.config";
const { Countdown } = Statistic;

class PromptPayPaymentPage extends React.Component {
  render() {
    const {
      qrString,
      amount,
      name,
      referenceId,
      accountNo,
      qrExpireTime,
      qrStatus,
      handleOnBack,
      uuid
    } = this.props;

    const isQrExpired = qrStatus === "expired";
    const deadline = qrExpireTime ? new Date(qrExpireTime).getTime() : 0;

    return (
      <div id="container" className="container">
        <div className="qr-section in">
          {/* หัวข้อและคำอธิบาย */}
          <div style={{ textAlign: "center" }}>
            <h2>สแกนเพื่อชำระเงิน</h2>
            <p>กรุณาสแกน QR Code นี้ภายในเวลาที่กำหนด</p>
          </div>

          {/* แสดงเวลาที่เหลือ หรือสถานะหมดอายุ */}
          <div className="countdown-container">
            {isQrExpired ? (
              <Statistic
                title="สถานะ"
                value="QR Code หมดอายุแล้ว"
                valueStyle={{ color: "#cf1322" }}
                prefix={<AlertOutlined />}
              />
            ) : (
              <Countdown
                title="เวลาที่เหลือ"
                value={deadline}
                onFinish={() => handleOnBack()}
                format="mm:ss"
              />
            )}
          </div>

          {/* กล่อง QR Code และข้อมูล */}
          <div className="qr-code-box">
            <div className="header-logos">
              <div className="logo-thai-qr">
                {config.web_name.toLocaleUpperCase()} QRCODE
              </div>
              <div className="logo-promptpay">
                <img src={iconPay} height={40} alt="PromptPay" />
              </div>
            </div>

            <div style={{ textAlign: "center", padding: "10px" }}>
              {/* แสดง QR Code จาก props หรือข้อความเมื่อหมดอายุ */}
              {isQrExpired || !qrString ? (
                <div className="qr-placeholder">
                  <p className="text-danger">ไม่พบ QR Code หรือหมดอายุแล้ว</p>
                  <Button
                    type="primary"
                    onClick={() => handleOnBack()}
                    icon={<ReloadOutlined />}
                  >
                    สร้างใหม่
                  </Button>
                </div>
              ) : (
                <QRCode
                  id="qrCodeImage"
                  type="canvas"
                  value={qrString}
                  size={200}
                  errorLevel="H"
                />
              )}
            </div>
              <p></p>
            <Descriptions bordered column={1} className="qr-info-descriptions">
              <Descriptions.Item label="ชื่อบัญชี">
                {name || "-"}
              </Descriptions.Item>
              <Descriptions.Item label="เลขบัญชี">
                {accountNo || "-"}
              </Descriptions.Item>
              <Descriptions.Item label="จำนวนเงิน">
                {amount ? amount.toLocaleString() : "-"}.-
              </Descriptions.Item>
              <Descriptions.Item label="Ref.">
                {referenceId || "-"}
              </Descriptions.Item>
              <Descriptions.Item label="UUID">
                {uuid || "-"}
              </Descriptions.Item>
            </Descriptions>

            <p className="account-name mt-5">
              <Button
              onClick={() => handleOnBack()}
                type="primary"
                disabled={isQrExpired}
                icon={<SafetyCertificateOutlined />}
              >
                โอนสำเร็จแล้ว
              </Button>
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default PromptPayPaymentPage;
